/*
 *
 * StoriesPage actions
 *
 */

const SCOPE = 'app/StoriesPage/';
export const ActionTypes = {
    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    SET_PAGE_LOADABLE_IDS: `${SCOPE}SET_PAGE_LOADABLE_IDS`,
    SET_PAGE_LOADED_IDS: `${SCOPE}SET_PAGE_LOADED_IDS`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,
};

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const setPageLoadableIds = (loadableIds) => ({
    type: ActionTypes.SET_PAGE_LOADABLE_IDS,
    loadableIds,
});
export const setPageLoadedIds = (loadedIds) => ({
    type: ActionTypes.SET_PAGE_LOADED_IDS,
    loadedIds,
});
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});
